type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object
    ? DeepPartial<T[P]>
    : T[P];
};

export default DeepPartial

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === "object" && value !== null && !Array.isArray(value);
};

export const mergeDeep = <T>(base: T, partial: DeepPartial<T>): T => {
  if (!isPlainObject(base) || !isPlainObject(partial)) {
    return partial !== undefined ? (partial as T) : base;
  }

  const result: Record<string, unknown> = { ...base };

  for (const key in partial) {
    if (!Object.prototype.hasOwnProperty.call(partial, key)) {
      continue;
    }

    const baseValue = (base as any)[key];
    const partialValue = (partial as any)[key];

    if (isPlainObject(baseValue) && isPlainObject(partialValue)) {
      result[key] = mergeDeep(baseValue, partialValue);
    } else if (partialValue !== undefined) {
      result[key] = partialValue;
    }
  }

  return result as T;
};
